import { render, staticRenderFns } from "./FondateurCard.vue?vue&type=template&id=3f5634d0&scoped=true&"
import script from "./FondateurCard.vue?vue&type=script&lang=js&"
export * from "./FondateurCard.vue?vue&type=script&lang=js&"
import style0 from "./FondateurCard.vue?vue&type=style&index=0&id=3f5634d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5634d0",
  null
  
)

export default component.exports